import { TransactionStatus } from '../../../../shared/schemas/transaction';
import { Component, effect, inject, input, model, signal } from '@angular/core';
import { Transaction } from '../../../../shared/schemas/transaction';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ReadableTimePipe } from '../../../../shared/utils/pipes/readable-time.pipe';
import { ModalService } from '../../../../shared/utils/services/modal.service';
import { ModalComponent } from '../../../../shared/ui/modal/modal.component';
import { TransactionService } from '../../../../shared/services/transaction.service';
import { BusinessService } from '../../../../shared/services/business.service';
import { PaymentAccount } from '../../../../shared/schemas/payment_account';

@Component({
  selector: 'qwiko-transaction-details',
  imports: [CommonModule, TranslocoModule, ReadableTimePipe, ModalComponent],
  templateUrl: './transaction-details.component.html',
  styleUrl: './transaction-details.component.scss',
})
export class TransactionDetailsComponent {
  modalService = inject(ModalService);
  transactionService = inject(TransactionService);
  latestTransaction = this.transactionService.latestTransaction;
  latestTransactionEffect = effect(() => {
    if (this.latestTransaction()) {
      this.transaction.set(this.latestTransaction());
    }
  });
  businessService = inject(BusinessService);
  transaction = model.required<Transaction | null>();
  transactionEffect = effect(() => {
    if (this.transaction()) {
      this.status.set(this.transaction()?.status! ?? null);
    }
  });
  loading = model.required<boolean>();
  transactionStatus = TransactionStatus;

  status = signal<TransactionStatus | null>(null);

  businessPaymentAccounts = this.businessService.businessPaymentAccounts;

  paymentAccount = signal<PaymentAccount | null>(null);
  isChoosePaymentAccount = signal<boolean>(false);
  isTransactionDetails = signal<boolean>(true);
  isChooseStatus = signal<boolean>(false);
  hasConfirmed = signal<boolean>(false);

  async confirmTransaction() {
    this.loading.set(true);

    if (this.status() !== this.transaction()?.status) {
      const transaction: Transaction = {
        id: this.transaction()?.id,
        status: this.status()!,
        receiver_status: this.status()!,
        receiver_account:
          this.paymentAccount()?.id ||
          (this.transaction()?.receiver_account as PaymentAccount)?.id ||
          null,
      };
      await this.transactionService.updateTransaction(transaction);
    } else {
      const transaction: Transaction = {
        id: this.transaction()?.id,
        status: this.transactionStatus.CONFIRMED,
        // sender_status: this.transactionStatus.CONFIRMED,
        receiver_status: this.transactionStatus.CONFIRMED,
        receiver_account:
          this.paymentAccount()?.id ||
          (this.transaction()?.receiver_account as PaymentAccount)?.id ||
          null,
      };
      await this.transactionService.updateTransaction(transaction);
    }
    this.hasConfirmed.set(true);
    this.loading.set(false);
  }

  addAccount(account?: PaymentAccount) {
    if (account) {
      this.paymentAccount.set(account);
      this.resetModalStates();
      return;
    }
    this.resetModalStates();
    this.isTransactionDetails.set(false);
    this.isChoosePaymentAccount.set(true);
  }

  changeStatus(status?: string) {
    this.hasConfirmed.set(false);
    if (
      this.transaction()?.status == this.transactionStatus.CONFIRMED ||
      this.transaction()?.status == this.transactionStatus.CANCELED
    ) {
      return;
    }
    if (status) {
      this.status.set(status as TransactionStatus);
      this.resetModalStates();
      return;
    }
    this.resetModalStates();
    this.isTransactionDetails.set(false);
    this.isChooseStatus.set(true);
  }

  back() {
    this.resetModalStates();
  }

  resetModalStates() {
    this.isChooseStatus.set(false);
    this.isChoosePaymentAccount.set(false);
    this.isTransactionDetails.set(true);
  }
  resetAllStates() {
    this.resetModalStates();
    this.paymentAccount.set(null);
    this.status.set(this.transaction()?.status!);
    this.hasConfirmed.set(false);
  }

  closeModal(modal?: string) {
    if (modal) {
      this.modalService.close(modal);
    } else {
      this.modalService.closeAll();
    }
    this.resetAllStates();
  }
}
